import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';

export function salaryListedFacet(i18n: I18nFn) {
  return {
    id: 'salaryListedFacet',
    name: 'hasSalary',
    get title() {
      return i18n('Salary Listed');
    },
    options: ['true', 'false'],
    optionTitles: {
      true: 'Yes',
      false: 'No',
    },
    type: 'boolean',
    sort: false,
  } as const satisfies SearchFacetData;
}
